import { severityPriority } from './severity';
import { parseFailureSummary } from './text';

const buildSummary = (groups) => {
  const counts = { critical: 0, serious: 0, moderate: 0, minor: 0, other: 0 };
  groups.forEach((group) => {
    const impact = group.impact || 'other';
    if (counts[impact] !== undefined) {
      counts[impact] += group.errors.length;
    } else {
      counts.other += group.errors.length;
    }
  });
  return counts;
};

const deriveGroupMessages = (groupErrors = []) => {
  if (!groupErrors.length) {
    return { sharedIntro: null, sharedDetails: [], items: [] };
  }

  const parsedSummaries = groupErrors.map((error) => {
    const summarySource = error?.failureSummary || error?.msg || '';
    return parseFailureSummary(summarySource);
  });

  const items = groupErrors.map((error, index) => {
    const parsed = parsedSummaries[index];
    const rawSummary = error?.failureSummary || error?.msg || '';

    return {
      error,
      summaryIntro: parsed.intro,
      summaryDetails: parsed.details,
      rawSummary,
    };
  });

  return { sharedIntro: null, sharedDetails: [], items };
};

const buildHintMessage = (result) => {
  if (!result) return null;
  const { usedFallback, fallbackLabel } = result;

  if (!usedFallback) {
    return null;
  }

  const label = fallbackLabel ? `"${fallbackLabel}"` : 'um conteúdo oculto';
  return {
    message: `O erro está dentro de ${label}.`,
    instruction:
      'Para localizar o elemento correspondente, abra este conteúdo e em seguida clique em Atualizar.',
    type: 'fallback',
    canRetry: true,
  };
};

const sortGroupsBySeverity = (groups) => {
  const clone = [...groups];
  clone.sort((a, b) => {
    return (
      (severityPriority[b.impact] || 0) - (severityPriority[a.impact] || 0)
    );
  });
  return clone;
};

export {
  buildHintMessage,
  buildSummary,
  deriveGroupMessages,
  sortGroupsBySeverity,
};
